module.exports = __webpack_public_path__ + "static/flags/ST-529855643bdb06d8cbafca1d393b6a19.gif";